// extracted by mini-css-extract-plugin
export default {"root":"IconWithMenuExtended__root--gy5vJ"};